import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const ContactInfo = ({ 
  className = "",
  customBusinessHours = null
}) => {
  const contactDetails = {
    phone: {
      number: "+91 8590442525",
      display: "+91 8590442525",
      description: "Call us for immediate assistance"
    },
    email: {
      address: "whitespacepropertiesclt@gmail.com",
      description: "Send us your detailed inquiry"
    },
    address: {
      company: "Whitespace Properties LLP",
      line1: "5th Floor, Elite Arcade,",
      line2: "Kannur Road, Chakkorthkulam,",
      line3: "Kozhikode, Kerala 673011"
    },
    businessHours: customBusinessHours || {
      weekdays: "Monday - Saturday: 9:00 AM - 6:00 PM",
      weekend: "Sunday: 10:00 AM - 4:00 PM"
    }
  };

  return (
    <div className={`space-y-8 ${className}`}>
      {/* Contact Details Card */}
      <div className="bg-white rounded-2xl p-4 sm:p-8 border border-gray-200">
        <h3 className="text-2xl font-medium text-gray-900 mb-6">Get in Touch</h3>
        
        <div className="space-y-6">
          {/* Phone */}
          <div className="flex items-start gap-4 group">
            <div className="w-12 h-12 bg-red-50 group-hover:bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-300">
              <Phone className="w-6 h-6 text-[var(--primarycolor)]" />
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-1">Phone</h4>
              <a 
                href={`tel:${contactDetails.phone.number}`}
                className="text-gray-600 hover:text-[var(--primarycolor)] transition-colors duration-300 text-base sm:text-lg font-medium"
              >
                {contactDetails.phone.display}
              </a>
              <p className="text-xs sm:text-sm text-gray-500 mt-1">{contactDetails.phone.description}</p>
            </div>
          </div>
          
          {/* Email */}
          <div className="flex items-start gap-4 group">
            <div className="w-12 h-12 bg-red-50 group-hover:bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-300">
              <Mail className="w-6 h-6 text-[var(--primarycolor)]" />
            </div>
            <div className="min-w-0 flex-1">
              <h4 className="font-semibold text-gray-900 mb-1">Email</h4>
              <a 
                href={`mailto:${contactDetails.email.address}`}
                className="text-gray-600 text-sm sm:text-base hover:text-[var(--primarycolor)] transition-colors duration-300 break-words block"
              >
                {contactDetails.email.address}
              </a>
              <p className="text-xs sm:text-sm text-gray-500 mt-1">{contactDetails.email.description}</p>
            </div>
          </div>
          
          {/* Address */}
          <div className="flex items-start gap-4 group">
            <div className="w-12 h-12 bg-red-50 group-hover:bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-300">
              <MapPin className="w-6 h-6 text-[var(--primarycolor)]" />
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-1">Office Address</h4>
              <address className="text-gray-600 not-italic leading-relaxed text-sm sm:text-base">
                {contactDetails.address.company}<br />
                {contactDetails.address.line1}<br />
                {contactDetails.address.line2}<br />
                {contactDetails.address.line3}
              </address>
              {/* <button className="text-red-600 hover:text-red-700 text-sm font-medium mt-2 transition-colors duration-300">
                View on Google Maps →
              </button> */}
            </div>
          </div>
          
          {/* Business Hours */}
          <div className="flex items-start gap-4 group">
            <div className="w-12 h-12 bg-red-50 group-hover:bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-300">
              <Clock className="w-6 h-6 text-[var(--primarycolor)]" />
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-1">Business Hours</h4>
              <div className="text-gray-600 space-y-1 text-sm sm:text-base">
                <p>{contactDetails.businessHours.weekdays}</p>
                {/* <p>{contactDetails.businessHours.weekend}</p> */}
              </div>
              {/* <p className="text-sm text-gray-500 mt-2">
                Emergency assistance available 24/7
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;